<fieldset>
	<legend>Annulation</legend>

	<fieldset>
		<legend>avisInitial</legend>
		<app-avis-initial-type
			[uid]="getUid()"
			[parentForm]="parentForm"
			[disabled]="disabled"
			
			[avisInitial]="annulation.avisInitial"
		></app-avis-initial-type>
	</fieldset>

	<!---->

	<app-form-input
		[parentForm]="parentForm"
		[disabled]="disabled"
		
		[value]="annulation.infosAnnulation"
		
		[label]="'infosAnnulation'"
		[type]="'text'"
		[rule]="''"
		[name]="getUid() + '_SepAtt_infosAnnulation'"
	>
	</app-form-input>
</fieldset>
